export const cognitoConfig = {
    userPoolId: 'us-east-1_3w1xG7L7Z', 
    userPoolClientId: '61tr5sd2g634r4m7qv32r2fibh', 
    region: 'us-east-1' 
}

